import type { InteractionTriggers } from '../types.js';

export const temporaryPan = ({
  deltaX,
  onPanChange,
}: {
  deltaX: number;
  onPanChange?: (event: {
    triggeredBy: InteractionTriggers;
    delta: number;
  }) => void;
}) => {
  const horizontal = deltaX && deltaX !== 0;
  if (horizontal) {
    onPanChange?.({ triggeredBy: 'pointer', delta: deltaX });
  }
};
